import { UserCog, Linkedin, Award, Telescope, PenSquare, BarChart3 } from "lucide-react";

const cards = [
  {
    span: "md:col-span-8 lg:col-span-7",
    bg: "bg-[#09090B] text-white",
    icon: UserCog,
    overline: "01 / Profile Overhaul",
    title: "Your profile, rebuilt as a brand.",
    body: "Most finance firms have a CV on LinkedIn. We rebuild yours into a brand asset — banner, headline, about, featured, services and proof — engineered so the right business owners trust you the moment they land on your page.",
    accent: true,
  },
  {
    span: "md:col-span-4 lg:col-span-5",
    bg: "bg-[#F4F4F5] text-[#09090B]",
    icon: Award,
    overline: "02 / Brand & Authority",
    title: "Reliable. Trustworthy. Repeated.",
    body: "Consistent positioning, niche clarity, and visible proof — so prospects don't have to wonder whether they can trust you with their books.",
  },
  {
    span: "md:col-span-4 lg:col-span-4",
    bg: "bg-white border border-[#E4E4E7] text-[#09090B]",
    icon: Telescope,
    overline: "03 / Partner Discovery",
    title: "Find companies already looking.",
    body: "We identify and engage business owners actively using LinkedIn to find finance partners — not random cold lists.",
  },
  {
    span: "md:col-span-4 lg:col-span-4",
    bg: "bg-white border border-[#E4E4E7] text-[#09090B]",
    icon: PenSquare,
    overline: "04 / Content Engine",
    title: "Posts that build trust over time.",
    body: "Weekly LinkedIn content written in your voice. Built to compound — so your name shows up when owners are ready to hire.",
  },
  {
    span: "md:col-span-4 lg:col-span-4",
    bg: "bg-[#1F4DA0] text-white",
    icon: Linkedin,
    overline: "05 / Outbound Conversations",
    title: "Human DMs. No automation.",
    body: "Personalized messaging in your voice, sent within safe daily limits. Every reply is qualified before it reaches your calendar.",
  },
  {
    span: "md:col-span-8 lg:col-span-4",
    bg: "bg-[#F4F4F5] text-[#09090B]",
    icon: BarChart3,
    overline: "06 / Honest Reporting",
    title: "What worked. What didn't.",
    body: "Weekly numbers: profile views, brand reach, DM response rate, qualified calls. No vanity metrics, no smoke.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 lg:py-28 border-b border-[#E4E4E7]"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#1F4DA0] mb-4">
              What we do
            </p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
              We build the brand. Then we bring the clients.
            </h2>
          </div>
          <p className="lg:max-w-sm text-base text-[#52525B]">
            A complete LinkedIn system for bookkeepers and finance firms. Brand first. Outreach second. Trust always.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className={`keepsy-card-hover ${c.span} ${c.bg} p-8 lg:p-10 relative`}
              >
                <div className="flex items-start justify-between mb-6">
                  <Icon size={28} strokeWidth={1.5} />
                  <span className="font-mono text-[10px] uppercase tracking-widest opacity-70">
                    {c.overline}
                  </span>
                </div>
                <h3 className="font-display font-bold text-xl sm:text-2xl tracking-tight leading-tight mb-3">
                  {c.title}
                </h3>
                <p className={`text-sm leading-relaxed ${c.bg.includes("text-white") ? "text-white/70" : "text-[#52525B]"}`}>
                  {c.body}
                </p>
                {c.accent && (
                  <div className="mt-8 pt-6 border-t border-white/20">
                    <img
                      src="https://images.unsplash.com/photo-1643962579745-bcaa05ffc573?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxmaW5hbmNpYWwlMjBkYXRhJTIwY2hhcnRzJTIwb24lMjBzY3JlZW58ZW58MHx8fHwxNzc4Njg2OTE3fDA&ixlib=rb-4.1.0&q=85"
                      alt="LinkedIn analytics growth"
                      className="w-full h-44 object-cover grayscale contrast-125 opacity-90"
                      loading="lazy"
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
